"use strict";

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.function.bind");

require("core-js/modules/es.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mkObservable = mkObservable;
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SafeObserver = /*#__PURE__*/function () {
  function SafeObserver(destination) {
    _classCallCheck(this, SafeObserver);

    _defineProperty(this, "destination", void 0);

    _defineProperty(this, "isUnsubscribed", false);

    _defineProperty(this, "unsub", void 0);

    this.destination = destination;
  }

  _createClass(SafeObserver, [{
    key: "next",
    value: function next(value) {
      // only try to next if you're subscribed have a handler
      if (!this.isUnsubscribed && this.destination.next) {
        try {
          this.destination.next(value);
        } catch (err) {
          // if the provided handler errors, teardown resources, then throw
          this.unsubscribe();
          throw err;
        }
      }
    }
  }, {
    key: "error",
    value: function error(err) {
      // only try to emit error if you're subscribed and have a handler
      if (!this.isUnsubscribed && this.destination.error) {
        try {
          this.destination.error(err);
        } catch (e2) {
          // if the provided handler errors, teardown resources, then throw
          this.unsubscribe();
          throw e2;
        }

        this.unsubscribe();
      }
    }
  }, {
    key: "complete",
    value: function complete() {
      // only try to emit completion if you're subscribed and have a handler
      if (!this.isUnsubscribed && this.destination.complete) {
        try {
          this.destination.complete();
        } catch (err) {
          // if the provided handler errors, teardown resources, then throw
          this.unsubscribe();
          throw err;
        }

        this.unsubscribe();
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.isUnsubscribed = true;

      if (this.unsub) {
        this.unsub();
      }
    }
  }]);

  return SafeObserver;
}();

function mkObservable(_subscribe) {
  return new Observable(_subscribe);
}

var Observable = /*#__PURE__*/function () {
  function Observable(_subscribe) {
    _classCallCheck(this, Observable);

    _defineProperty(this, "_subscribe", void 0);

    this._subscribe = _subscribe;
  } // @ts-ignore:


  _createClass(Observable, [{
    key: "pipe",
    value: function pipe() {
      for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
      }

      return fns.reduce(function (state, fn) {
        return fn(state);
      }, this);
    }
  }, {
    key: "subscribe",
    value: function subscribe(observer) {
      var safeObserver = new SafeObserver(observer);
      safeObserver.unsub = this._subscribe(safeObserver);
      return safeObserver.unsubscribe.bind(safeObserver);
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;